import { useCallback, useMemo } from 'react';

import { useAuth } from 'context/AuthContext';
import { GetVersion } from 'services/utils';

/** O que uma tela precisa de um ciclo do seu recorte. */
export interface CicloDoRecorte {
  _id: string;
  title: string;
  date_start: number;
}

/**
 * O ciclo de uma tela com seletor próprio (CIC-10 a CIC-12): é o ciclo do app, quando ele está no recorte da
 * tela. Sem estado próprio, o seletor da tela e o do menu nunca divergem: trocar em um troca no outro.
 *
 * - `ciclo`: o ciclo do app, se a tela o tem;
 * - `foraDaTela`: o ciclo do app, quando a tela não o tem (para o aviso);
 * - `maisRecente`: o ciclo mais recente do recorte (o botão do aviso);
 * - `trocar(id)`: grava o ciclo do app, com a versão, como o seletor do menu.
 */
export function useCicloDaTela<T extends CicloDoRecorte>(ciclos: T[]) {
  const { cycleSelected, setCycleSelected } = useAuth();

  const ciclo = ciclos.find(item => item._id === cycleSelected?._id);
  const foraDaTela = cycleSelected && ciclos.length > 0 && !ciclo ? cycleSelected : undefined;
  const maisRecente = useMemo(
    () =>
      ciclos.reduce<T | undefined>(
        (recente, item) => (!recente || item.date_start > recente.date_start ? item : recente),
        undefined,
      ),
    [ciclos],
  );

  const trocar = useCallback(
    (cicloId: string) => {
      const escolhido = ciclos.find(item => item._id === cicloId);
      if (escolhido) setCycleSelected({ _id: escolhido._id, title: escolhido.title, version: GetVersion(escolhido.date_start) });
    },
    [ciclos, setCycleSelected],
  );

  return { ciclo, foraDaTela, maisRecente, trocar };
}
